import { render, staticRenderFns } from "./resource-grade-user.vue?vue&type=template&id=448c78bb&scoped=true"
import script from "./resource-grade-user.vue?vue&type=script&lang=js"
export * from "./resource-grade-user.vue?vue&type=script&lang=js"
import style0 from "./resource-grade-user.vue?vue&type=style&index=0&id=448c78bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c78bb",
  null
  
)

export default component.exports